import { FC } from 'react'
import * as React from 'react'
import { isEmpty } from 'lodash'
import useFormProcessor from '@hooks/useFormProcessor'
import AddNewItemModalLayout from '@templates/AddNewItemModalLayout'
import {
  CommonRiskMapJobPositionBody,
  RiskMapJobPositionDetailed,
} from '@models/riskMapJobPosition'
import {
  useCreateMultipleRiskMapPositionsMutation,
  useUpdateRiskMapPositionMutation,
} from '@services/riskMapJobPositions'
import Title from '@organisms/Title'
import MultilineFieldNew from '@templates/MultilineFieldNew'
import useRiskMapPositionsField from '@hooks/useRiskMapPositionsField'
import { Option } from '@organisms/Select'
import DangersFields from './DangersFields'
import getDefaultValues from './getDefaultValues'

export type FormValues = {
  titles: Option[]
  dangerDTOs: {
    id?: string
    kind?: Option
    event?: Option
    workPlace?: Option
    object?: Option
    hazard?: Option
  }[]
}

type Props = {
  isEdit?: boolean
  handleCloseModal: () => void
  riskMapPosition?: Partial<RiskMapJobPositionDetailed>
}

const PositionAndDangersModal: FC<Props> = ({
  isEdit,
  riskMapPosition,
  handleCloseModal,
}) => {
  const [create, createData] = useCreateMultipleRiskMapPositionsMutation()
  const [update, updateData] = useUpdateRiskMapPositionMutation()
  const additionalProps = isEdit ? updateData : createData

  const methods = useFormProcessor({
    apiErrors: additionalProps.error,
    defaultValues: getDefaultValues(riskMapPosition),
  })

  const { field: positionsField } = useRiskMapPositionsField({
    label: 'Наименование',
    name: 'title',
    isRequired: true,
    isDisabled: isEdit,
    promptText: '',
  })

  const handleSubmitForm = (form: FormValues) => {
    const commonForm: CommonRiskMapJobPositionBody = {
      riskMapJobPositionDangers: !isEmpty(form.dangerDTOs?.[0]?.workPlace)
        ? form.dangerDTOs?.map(({ event, kind, workPlace, object, hazard }) => {
            return {
              hazard: hazard?.value || null,
              event: event?.value || null,
              kind: kind?.value || null,
              object: object?.value || null,
              workPlace: workPlace?.value || null,
            }
          })
        : [],
    }

    if (isEdit) {
      if (riskMapPosition && riskMapPosition.id) {
        update({
          ...commonForm,
          id: riskMapPosition.id,
          title: riskMapPosition.title,
        })
      }
    } else {
      create({
        ...commonForm,
        titles: form.titles.map(({ label }) => label),
      })
    }
  }

  return (
    <AddNewItemModalLayout
      {...additionalProps}
      titlePostfix="должности / опасности"
      onSubmitForm={handleSubmitForm}
      methods={methods}
      withSaveAndAddMore
      handleCloseModal={handleCloseModal}
      isEdit={isEdit}
      withoutAddMore
    >
      <Title>Должность</Title>
      <MultilineFieldNew
        fieldsSrc={[positionsField()]}
        fieldsName="titles"
        amendValue={{}}
        isDisabled={isEdit}
      />
      <DangersFields />
    </AddNewItemModalLayout>
  )
}

export default PositionAndDangersModal
